import { IconType } from "@common/declarations";
import React from "react";
import { useSlate } from "slate-react";
import AiButton from "./Ai/Button";
import MenuButtonBase from "./Buttons/Base";
import CodeviewButton from "./Buttons/Codeview";
import ForeColorButton from "./Buttons/ForeColor";
import FullScreenButton from "./Buttons/FullScreen";
import { RichEditorContext } from "./context";
import { FORMAT_ICONS, isCustomType, isMenuButtonActive, toggleMenuButton } from "./lib";
import LinkButton from "./Link/Button";
import { type RichEditorToolbarFixedButton } from "./types";

type Props = {
  caption?: string;
  dropdownClassName?: string;
  format: RichEditorToolbarFixedButton;
};
const FixedMenuButton = ({ caption, dropdownClassName, format }: Props) => {
  const editor = useSlate();
  const context = React.useContext(RichEditorContext);

  if (isCustomType(format)) {
    switch (format) {
      case "ai":
        return <AiButton />;
      case "codeview":
        return <CodeviewButton />;
      case "forecolor":
        return <ForeColorButton dropdownClassName={dropdownClassName} isDisabled={context.isCodeview} />;
      case "fullscreen":
        return <FullScreenButton />;
      default:
        return <span>{format}</span>;
    }
  }

  if (format === "a") {
    return <LinkButton dropdownClassName={dropdownClassName} isDisabled={context.isCodeview} />;
  }

  return (
    <MenuButtonBase
      caption={caption}
      isActive={isMenuButtonActive(editor, format)}
      isDisabled={context.isCodeview}
      onMouseDown={() => toggleMenuButton(editor, format)}
      icon={FORMAT_ICONS[format] ?? IconType.Palette}
    />
  );
};
export default FixedMenuButton;
